/**
 * Created by Mark on 24/04/2017.
 */


import React from "react";
import {ProgressBar , ButtonGroup , Row, Col , Button , Badge , Modal} from 'react-bootstrap';
import Translation from '../../../../store/internationalization-store.js';
import Table from '../../../../components/general_table.js';
import HomeworkWidget from '../../../../components/homework'
import AssignmentsService from '../../../../services/assignments-service'
import Popup from '../../../../components/popup/comfirmation_popup.js'
import FieldGroup from '../../../../components/FieldGroup.js';
import {AccountService} from '../../../../services';


let colRanges = [
    {thresholdLower:70 , thresholdHigher:100 , total:0 , color:"#88c057"},
    {thresholdLower:40 , thresholdHigher:70  , total:0 , color:"#ffcc66"},
    {thresholdLower:1 , thresholdHigher:40   ,  total:0 , color:"#ed7161"},
    {thresholdLower:0 , thresholdHigher:0   ,  total:0 , color:"#ffffff"}
];

class AboutPanel extends React.Component {

    constructor(props) {
        super();

        this.props = props;

        this.state = {
            loading:true,
            students:[],
        }
        this.uid = this.props.data.homeworkID;
    }


    componentDidMount(){
        AssignmentsService.getUsersCompleted(this.props.data.homeworkID).then(function(students){
            var completed  = 0;
            var overdue = 0;
            var inProgress = 0;
            for(var idx = 0 ; idx < students.length; idx++ )
            {
                completed  += Number(students[idx].completed);
                overdue  += Number(students[idx].overdue);
                inProgress += Number(students[idx].inProgress);
            }

            AssignmentsService.getScores(this.props.data.homeworkID).then(function(response) {
                var table = response.table;
                var t  = {};
                for (var idx = 0; idx < table.length; idx++) {
                    var total = 0;
                    var number = 0;
                    for (var jdx = 0; jdx < response.headers.length; jdx++) {
                        table[idx][response.headers[jdx].name]['question-name'] = null;
                        table[idx][response.headers[jdx].name + "-percentage"] = table[idx][response.headers[jdx].name]['percentage'];
                        if (table[idx][response.headers[jdx].name]['percentage']) {
                            number++;
                            var newNumber = Number(table[idx][response.headers[jdx].name]['percentage'].replace(/[^0-9\-]/g, ''));
                            if (newNumber != -1) {
                                total += newNumber;
                            }
                        }

                    }

                    t[table[idx].uid] = isNaN(total) || total == 0 ? "-%" : String(Math.ceil(total / number)) + "%"
                }


                this.setState({
                    averages:t,
                    students:students,
                    totalComplete:completed,
                    totalIncomplete:1,
                    totalOverdue:overdue,
                    totalStudents:students.length,
                    inProgress:inProgress,
                    loading:false
                })

            }.bind(this))



        }.bind(this));

    }

    getTableData(){

        var s = this.state.students || [];
        if(this.state.isCompleted)
        {
            var r = [];


            for(var i = 0 ; i < s.length; i ++)
            {
                let row = s[i];

                if(row.totalTasks != row.completed_tasks)
                {
                    r.push(row)
                }
            }


            return r;
        }

        return s
    }


    renderStudentLink(cell , row){
        return         <a href={"#/students/news/" + row.uid}>
            <i className="zmdi zmdi-link p-r-5"></i>{row.student_name}
        </a>
    }

    renderClasses(cell){

            var string = "";

            for(var idx = 0 ; idx < cell.length; idx++){

                string += ' ' + cell[idx].name

            }

            console.log(string)

            return string

    }

    renderCompleted(cell , row){

        console.log(row)

        return <span>{String(row.completed_tasks)} &#8260; {String(row.totalTasks)}</span>

    }

    getBadge(){

        if(this.props.data.homework.completed == true) return <Badge>{Translation.get('772' , 'Terminé')}</Badge>
        //TEST DATE
        return <Badge>{Translation.get('12166', 'En cours')}</Badge>
    }

    renderBar(){


        var onGoTo = function(uid){
            window.location.href = "#/assign/duplicate/" + uid
        };

        var deleteHomework = function(){
            this.setState({showDeleted:true});
        };


        var onArchivedHomework = function(){
            this.setState({showArchived:true});
        };

        return <div> <Row>

            <Col md={6}>
                <h6>
                    {this.props.data.homework.name}&nbsp;&nbsp;
                    <small>
                        {Translation.get('12104', 'Due Date')}&nbsp;:&nbsp;{this.props.data.homework.due}</small>
                </h6>
            </Col>
            <Col md={6}>
                <ButtonGroup className="float-right" aria-label="Basic example">
                <Button size="sm" variant="outline-secondary" className="float-right" onClick={onArchivedHomework.bind(this)}>{Translation.get('872' , 'Devoirs archivés')}</Button>
                <Button size="sm" variant="outline-secondary" className="float-right" onClick={deleteHomework.bind(this)} >{Translation.get('444' , 'Effacer')}</Button>
                <Button size="sm" variant="outline-secondary" className="float-right" onClick={onGoTo.bind(this , this.props.data.homeworkID)} > 
                {Translation.get('12259' , 'Homework Profile')}</Button>
                </ButtonGroup>
            </Col>
        </Row>
            </div>
    }

    deleteObject(){
        /*
        var uid =   this.uid;
        
        AssignmentServices.setDeleted(uid , "1").then(function(response){
            AssignmentServices.getViewableHomework().then(function(response){

                window.location.hash = 'assignment/managment';
            }.bind(this));
        }.bind(this))
        */
    }

    archiveObject(){
        /*
        var uid =   this.uid;
        
        AssignmentServices.setArchived(uid , "1").then(function(response){
            AssignmentServices.getViewableHomework().then(function(response){
                window.location.hash = 'assignment/managment';
            }.bind(this));
        }.bind(this))
        */
    }

    closeDeleted(){
        this.setState({showDeleted:false});
    }

    closeArchived(){
        this.setState({showArchived:false});
    }

    render(){

        if(this.state.loading)
        return <ProgressBar animated now={45} />
        //if(this.state.students.length <= 0) return "";

        var popup = <Popup oneButton={true} buttonTitle={Translation.get(12787, "Send")} title={this.state.studentName} 
        onSave={()=>{
            AccountService.createMessageStudent(this.state.messageTitle, this.state.messageMessage, this.state.studentUid)
            this.setState({addMessage:false});
        }} 
        onHide={()=>{
            this.setState({addMessage:false});
        }} 
        show={this.state.addMessage} 
        body={<div>
                <Row >
                    <Col sm={{span: 12}}>
                        <FieldGroup value={this.state.messageTitle} 
                                onSelect={(event)=>{
                                    this.setState({lastSelected:event.target, lastSelectType:"title", lastPosition:undefined});
                                }} 
                                onChange={(event)=>{ this.setState({messageTitle:event.target.value}) }} 
                                className="strong" as="input" label={Translation.get(2202, 'Title')}  type="input" autofocus="true"/>
                    </Col>
                </Row>
                <Row >
                    <Col sm={{span: 12}}>
                        <FieldGroup value={this.state.messageMessage} 
                                    onSelect={(event)=>{
                                        this.setState({lastSelected:event.target, lastSelectType:"message", lastPosition:undefined});
                                    }} 
                                    onChange={(event)=>{ this.setState({messageMessage:event.target.value}) }} 
                                    className="strong" as="input" label={Translation.get(12778, 'Subject')}  type="input" as="textarea" rows="3" />
                    </Col>
                </Row>
                {AccountService.getEmojiData(this)}
            </div>} />

        let cols = [{
            dataField: 'student_name',
            text: Translation.get(827, 'Student Name'),
            sort: true,
            // formatter:this.renderStudentLink.bind(this)},
        },
            {
                dataField: 'classes',
                text: Translation.get(830,'Classes'),
                formatter:this.renderClasses.bind(this),
                csvFormatter:(cell , row)=>{
                    var data = "";
                    for (var i = 0; i < cell.length; i++) {
                        data += cell[i].name;
                        data += ", ";
                    }
                    return data;
                }
            },{
                dataField: 'completed_tasks',
                text: Translation.get(12669,'Tasks Completed'),
                formatter:this.renderCompleted.bind(this),
                sort:true
            },{
                dataField: 'uid',
                text: Translation.get(12223,'Average'),
                formatter:function(cell){
                    return this.state.averages[cell];
                }.bind(this),
                style: (one , two , three)=>{

                    let col = null;
                    one = this.state.averages[one];
                    var test = function(value , thresholdLower , thresholdHigher){

                        value = String(value).replace('%' , '');

                        if(value == 0 && thresholdLower == 0)
                        {
                            return true;
                        }

                        return value > Number(thresholdLower) && value <= Number(thresholdHigher)
                    };

                    for(var r = 0 ; r < colRanges.length; r++)
                    {
                        if(test( one , colRanges[r].thresholdLower , colRanges[r].thresholdHigher))
                        {
                            col = colRanges[r].color
                            break;
                        }
                    }

                    return {
                        fontWeight: 'bold',
                        width: '10%',
                        background:col
                    }
                },
            },{
                dataField: 'message',
                text:"",
                csvExport: false,
                formatter: (cell, row)=>{
                    return <div onClick={function() {
                        console.log(row);
                        this.setState({addMessage:true, messageMessage:"", messageTitle:this.props.data.homework.name, studentUid:row.uid, studentName:row.name});
                    }.bind(this)}><i class="fas fa-envelope"></i></div>;
                }
            }
        ];

        return  <div>
            {popup}
            <Modal show={this.state.showDeleted} onHide={this.closeDeleted.bind(this)}>
                <Modal.Header>
                    <Modal.Title>{Translation.get('444' , 'Effacer')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {Translation.get('223', 'Are You Sure')}
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={this.closeDeleted.bind(this)}>
                        {Translation.get('41', 'Cancel')}
                    </Button>
                    <Button onClick={this.deleteObject.bind(this)} bsStyle="danger">Translation.get('444' , 'Effacer')</Button>
                </Modal.Footer>

            </Modal>
            <Modal show={this.state.showArchived} onHide={this.closeArchived.bind(this)}>
                <Modal.Header>
                    <Modal.Title>
                        {Translation.get('12200', 'Archive?')}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {Translation.get('667', 'Are You Sure')}
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={this.closeArchived.bind(this)}>
                        {Translation.get('41', 'Cancel')}
                    </Button>
                    <Button onClick={this.archiveObject.bind(this)} bsStyle="danger">{Translation.get('872' , 'Devoirs archivés')}</Button>
                </Modal.Footer>

            </Modal>
                     <div className="pmb-block">
                         <div className="palette-Branding secondary bg" id="assignments-block">
                             <Row>
                                 <Col md={12}>
                                     <b style={{padding:"10px"}}>{Translation.get(12670 , 'Student Progress')}</b>
                                    <HomeworkWidget totalInProgress={this.state.inProgress} totalComplete={this.state.totalComplete} totalIncomplete={this.state.totalIncomplete}  totalOverdue={this.state.totalOverdue}  studentTotal={this.state.totalStudents}/>
                                 </Col>
                             </Row>
                         </div>
                         <div style={{paddingTop:"10px"}} className="pmbb-body">
                             <Table component={<div style={{marginTop:'10px'}}><a  onClick={()=>{this.setState({isCompleted:!this.state.isCompleted})}} class="hyperlink">{this.state.isCompleted ? Translation.get(243 , 'Show all') : Translation.get(12766 , 'Show Incomplete')}</a></div>} hideDownload columns={cols} data={ this.getTableData() } />
                         </div>
                     </div>
                </div>;
    }
}

export default {
    name: function() {return Translation.get('2216' , 'Overview')},
    component: AboutPanel
}